import { gql } from 'urql'
export const FragPopularCategoriesSection = gql`
  fragment PopularCategoriesSection on PopularCategoriesSection {
    __typename
    id
    title
    items {
      __typename
      id
      title
      slug
      backgroundColor
      iconUrl
    }
    navigationActions {
      targetPageId
      label
    }
  }
`
